"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowProfile = void 0;
exports.windowProfile = {
    name: 'window',
    methods: ['prompt', 'confirm', 'alert'],
};
//# sourceMappingURL=profile.js.map